module.exports = __webpack_public_path__ + "static/media/Frame.12c2bf55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Frame.png
// module id = 72
// module chunks = 0